import { STYLE_ID, type CustomMap } from "./themeConstants";
import { readPreset, readCustom, writePreset, writeCustom } from "./themeStorage";
import { fetchTheme } from "./themeApi";

export function applyPreset(id: string) {
  if (typeof document === "undefined") return;
  if (id) document.documentElement.setAttribute("data-theme", id);
  else document.documentElement.removeAttribute("data-theme");
}

export function applyCustom(map: CustomMap) {
  if (typeof document === "undefined") return;
  let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  const entries = Object.entries(map).filter(([, v]) => !!v);
  if (entries.length === 0) {
    if (style) style.remove();
    return;
  }
  if (!style) {
    style = document.createElement("style");
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  // Override ở mức :root để thắng cả preset data-theme.
  const decls = entries.map(([k, v]) => `--${k}: ${v} !important;`).join("");
  style.textContent = `:root, :root[data-theme] { ${decls} }`;
}

/** Gọi 1 lần ở app start. Áp preset + custom overrides. */
export function applyStoredTheme() {
  if (typeof document === "undefined") return;
  // 1) Áp local ngay để tránh flash, sau đó đồng bộ với backend (best-effort).
  applyPreset(readPreset());
  applyCustom(readCustom());
  void syncRemoteTheme();
}

/**
 * Lấy theme từ backend và áp lại. Nếu API lỗi giữ nguyên theme local — KHÔNG
 * crash, KHÔNG làm trắng trang. Cache vào localStorage để fallback lần sau.
 */
export async function syncRemoteTheme(): Promise<void> {
  if (typeof document === "undefined") return;
  try {
    const remote = await fetchTheme();
    if (!remote) return;
    applyPreset(remote.preset);
    applyCustom(remote.custom);
    writePreset(remote.preset);
    writeCustom(remote.custom);
  } catch {
    // im lặng — fallback local theme đã áp ở applyStoredTheme.
  }
}
